import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal, Text, LocalizedLink, DynamicContainer } from 'modules/ui';

import Config from '../../../../config';
import { impressum } from '../../../../constants';

import Cookies from './Cookies';

const {
    env: { IS_DE_LANG_ENV },
} = Config;

function createMarkup() {
    return { __html: impressum };
}

const ModalContentType = {
    Cookies: 'cookies',
    Impressum: 'impressum',
    None: false,
};

const ModalContentTypeToContent = {
    [ModalContentType.Cookies]: <Cookies />,
    [ModalContentType.Impressum]: <div dangerouslySetInnerHTML={createMarkup()} />,
};

const CopyRight = ({ styles, rules }) => {
    const [currentModalContentType, setCurrentModalContentType] = React.useState(ModalContentType.None);

    return (
        <DynamicContainer extend={rules.extendContainer} columns={5}>
            <Text extend={rules.extendText}>
                <FormattedMessage id="footer.copyright.firstLine" />
            </Text>
            <Text extend={rules.extendText}>
                <LocalizedLink className={styles.link} to={Config.routes['/cookiesPage']}>
                    <FormattedMessage id="footer.copyright.cookies" />
                </LocalizedLink>
                {IS_DE_LANG_ENV ? (
                    <button
                        type="button"
                        className={styles.link}
                        onClick={() => setCurrentModalContentType(ModalContentType.Impressum)}
                    >
                        <FormattedMessage id="footer.copyright.impressum" />
                    </button>
                ) : null}
            </Text>

            <Modal
                open={Boolean(currentModalContentType)}
                grid={currentModalContentType === ModalContentType.Cookies}
                onOpenChange={() => setCurrentModalContentType(ModalContentType.None)}
            >
                {ModalContentTypeToContent[currentModalContentType]}
            </Modal>
        </DynamicContainer>
    );
};

CopyRight.propTypes = {
    styles: PropTypes.shape({ container: PropTypes.string.isRequired, link: PropTypes.string.isRequired }).isRequired,
    rules: PropTypes.shape().isRequired,
};

export default CopyRight;
